import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { endpoints, APIError } from "@/lib/api";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/Card";

export default function Login() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");

  const login = useMutation({
    mutationFn: (t: string) => endpoints.login(t),
    onSuccess: () => navigate("/", { replace: true }),
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!token) return;
    login.mutate(token);
  };

  let errorMsg: string | null = null;
  if (login.isError) {
    errorMsg =
      login.error instanceof APIError && login.error.status === 401
        ? "令牌无效"
        : `登录失败: ${login.error.message}`;
  }

  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Bitbase KOL</CardTitle>
          <CardDescription>
            输入管理员 Bearer Token。开发模式可用 <code>--token=...</code> 启动
            参数对应的值；生产部署用 secrets.enc.yaml 里的{" "}
            <code>admin.bearer_token</code>。
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <Input
              type="password"
              placeholder="Bearer token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              autoFocus
              disabled={login.isPending}
            />
            {errorMsg && (
              <p className="text-sm text-destructive">{errorMsg}</p>
            )}
            <Button
              type="submit"
              className="w-full"
              disabled={login.isPending || !token}
            >
              {login.isPending ? "登录中…" : "登录"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
